class ConfigText {
    liveLabel = '';

    constructor() {
        Object.seal(this);
    }
}

export default ConfigText;
